import { dataImageAdd } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImageAdd = /*#__PURE__*/createIcon(dataImageAdd)
export default IconImageAdd
